function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("g", null);

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  version: 1.1,
  id: "Capa_1",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 420.704 420.704",
  style: {
    "enableBackground": "new 0 0 420.704 420.704"
  },
  xmlSpace: "preserve"
}, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#80362D"
  },
  d: "M269.575,12.724l-46.062,250.052l32.902,6.58C326.056,218.359,355.941,12.724,269.575,12.724z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#80362D"
  },
  d: "M269.575,12.724c-11.516-6.992-72.293-24.749-118.446,0 C94.374,43.158,44.747,152.007,124.808,262.776c0.114,0.157,59.223-6.58,59.223-6.58L269.575,12.724z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#FFD7A3"
  },
  d: "M256.772,232.084h-0.358v-15.37H164.29v15.354c0,15.042-0.063,31.392-13.161,41.282v147.354 h59.223c0,0,31.011,0,59.223,0V273.12C256.812,263.205,256.772,246.997,256.772,232.084z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#545465"
  },
  d: "M210.352,354.9c-14.15,0-27.502-1.876-39.482-5.134v70.937h92.124v-75.279 C248.066,351.381,229.941,354.9,210.352,354.9z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#FDC88E"
  },
  d: "M262.994,302.258c2.401,0.655,4.563,1.004,6.58,1.174V273.12 c-12.762-9.915-12.803-26.124-12.803-41.037l-0.009-0.382v-15.37l-72.732,0.382l-19.741,6.58 C177.45,238.1,217.755,289.92,262.994,302.258z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#FFE1B2"
  },
  d: "M302.476,131.169c0,52.696-52.408,118.446-92.124,118.446s-92.124-65.75-92.124-118.446 s41.246-72.384,92.124-72.384S302.476,78.473,302.476,131.169z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#80362D"
  },
  d: "M223.512,25.884c-3.697,0-15.701,4.154-25.512,7.794l-0.809-1.214c0,0-1.354,1.064-3.698,2.908 c-5.457,2.072-9.462,3.672-9.462,3.672l1.539,2.566c-24.976,19.678-81.96,64.693-87.084,69.818 c-6.58,6.58,39.482,174.464,39.482,78.964c0-79.786,44.327-95.587,85.544-105.285c18.644-4.387,24.128-15.354,26.321-26.321 C252.027,47.819,230.093,25.884,223.512,25.884z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#80362D"
  },
  d: "M243.253,65.366c12.064,43.32,36.192,62.924,58.812,68.682c12.395,3.155,6.992-35.78,6.992-35.78 s-17.548-44.966-19.741-46.062c-2.193-1.097-19.741-39.482-19.741-39.482l-39.482,32.902L243.253,65.366z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#E4EBF0"
  },
  d: "M158.355,265.465c-6.163,10.013-18.728,17.052-44.514,17.052h-2.193 c-39.976,0-72.384,32.407-72.384,72.384v46.062c0,10.902,8.838,19.741,19.741,19.741h135.028L158.355,265.465z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#E4EBF0"
  },
  d: "M262.349,265.465c6.163,10.013,18.728,17.052,44.514,17.052h2.193 c39.976,0,72.384,32.407,72.384,72.384v46.062c0,10.902-8.838,19.741-19.741,19.741H226.671L262.349,265.465z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  style: {
    "fill": "#D0D7DC"
  },
  cx: 111.647,
  cy: 387.802,
  r: 19.741
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#D0D7DC"
  },
  d: "M333.783,410.338l-8.135-5.591c7.229-10.518,11.376-26.288,11.376-43.267 c0-29.427-12.807-54.288-27.966-54.288s-27.966,24.861-27.966,54.288c0,16.979,4.146,32.749,11.376,43.267l-8.135,5.591 c-8.331-12.123-13.111-29.931-13.111-48.858c0-35.977,16.619-64.158,37.837-64.158c21.217,0,37.837,28.182,37.837,64.158 C346.893,380.407,342.114,398.215,333.783,410.338z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  style: {
    "fill": "#545465"
  },
  cx: 289.316,
  cy: 407.543,
  r: 6.58
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  style: {
    "fill": "#545465"
  },
  cx: 328.798,
  cy: 407.543,
  r: 6.58
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#D0D7DC"
  },
  d: "M111.647,379.577c-2.726,0-4.935-2.209-4.935-4.935c0-85.274,40.304-108.646,42.02-109.599 c2.387-1.329,5.388-0.466,6.71,1.917c1.321,2.374,0.472,5.367-1.892,6.698c-0.484,0.28-36.968,22.172-36.968,100.984 C116.582,377.368,114.373,379.577,111.647,379.577z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  style: {
    "fill": "#B2B9BF"
  },
  cx: 111.647,
  cy: 387.802,
  r: 10.419
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#D0D7DC"
  },
  d: "M309.057,307.195c-2.034,0-3.938-1.268-4.654-3.295c-4.288-12.15-11.268-17.291-11.337-17.339 c-2.233-1.563-2.776-4.641-1.213-6.874c1.563-2.23,4.636-2.774,6.874-1.213c0.389,0.273,9.585,6.842,14.984,22.143 c0.908,2.569-0.442,5.388-3.012,6.296C310.155,307.103,309.601,307.195,309.057,307.195z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#FFE1B2"
  },
  d: "M292.676,131.771c10.767-2.468,17.821,2.805,17.821,13.161c0,13.709-14.479,47.296-29.701,26.321 S292.676,131.771,292.676,131.771z"
}))), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);

export default __webpack_public_path__ + "static/media/3.9364088b.svg";
export { SvgComponent as ReactComponent };